import { useEffect } from "react";

// Houdt een overzicht actueel: stil herladen elke `interval` ms en zodra het tabblad weer focus/zichtbaar wordt.
export function useLiveRefresh(herlaad, deps = [], { interval = 60000, actief = true } = {}) {
  useEffect(() => {
    if (!actief) return undefined;
    const tick = () => { if (document.visibilityState === "visible") herlaad(); };
    const iv = setInterval(tick, interval);
    const opFocus = () => { if (document.visibilityState === "visible") herlaad(); };
    window.addEventListener("focus", opFocus);
    document.addEventListener("visibilitychange", opFocus);
    return () => { clearInterval(iv); window.removeEventListener("focus", opFocus); document.removeEventListener("visibilitychange", opFocus); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actief, interval, ...deps]);
}

export function LiveIndicator({ tijd, tid = "live-bijgewerkt" }) {
  if (!tijd) return null;
  return (
    <span className="text-[11px] text-slate-500" data-testid={tid}>
      Live · bijgewerkt {tijd.toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit", second: "2-digit" })} · ververst elke minuut
    </span>
  );
}
